export default function() {}



//////////////////
// WEBPACK FOOTER
// /Users/chrisessig/Documents/tribune/github/redistricting-CD27/node_modules/d3-shape/src/noop.js
// module id = null
// module chunks = 